// extracted by mini-css-extract-plugin
export default {"operatingHoursButton":"OperatingHoursButton-module__operatingHoursButton___1ETa8","buttonText":"OperatingHoursButton-module__buttonText___1890F"};